import {toast} from 'react-toastify';
import {actions} from 'react-redux-form';
import api from '../irelandApi';
import {
  GET_APP_SETTINGS_FULFILLED,
  GET_APP_SETTINGS_PENDING,
  GET_APP_SETTINGS_REJECTED,
  POST_APP_SETTINGS_REJECTED,
  POST_APP_SETTINGS_PENDING,
  POST_APP_SETTINGS_FULFILLED,
  POST_NEW_API_KEY_FULFILLED,
  POST_NEW_API_KEY_PENDING,
  POST_NEW_API_KEY_REJECTED
} from '../reducers/appSettingsReducer';
import {
  GET_USER_ACCESS_TOKENS_REJECTED,
  GET_USER_ACCESS_TOKENS_FULFILLED,
  GET_USER_ACCESS_TOKENS_PENDING,
  GET_USER_ACCESS_TOKEN_REJECTED,
  GET_USER_ACCESS_TOKEN_FULFILLED,
  GET_USER_ACCESS_TOKEN_PENDING,
} from '../reducers/accessTokenReducer';

export const getAppSettings = () => (dispatch) => {
  dispatch({
    type: GET_APP_SETTINGS_PENDING,
  });

  return api.get('/api/admin/app_settings')
    .then((response) => {
      dispatch({
        type: GET_APP_SETTINGS_FULFILLED,
        payLoad: response.data
      });

      dispatch(actions.load('deep.app_version', response.data.app_version));
    })
    .catch((error) => {
      dispatch({
        type: GET_APP_SETTINGS_REJECTED,
        payLoad: error
      });
    });
};

export const saveAppVersion = payLoad => (dispatch) => {
  dispatch({
    type: POST_APP_SETTINGS_PENDING,
  });
  return api.post('/api/admin/app_versions', {app_version: payLoad})
    .then(() => {
      dispatch({
        type: POST_APP_SETTINGS_FULFILLED,
        payLoad,
      });

      toast.success('App version has been successfully updated');
    })
    .catch((error) => {
      dispatch({
        type: POST_APP_SETTINGS_REJECTED,
        payLoad: error
      });

      toast.error('Cannot update app version');

      Promise.reject(error);
    });
};

export const generateApiKey = () => (dispatch) => {
  dispatch({type: POST_NEW_API_KEY_PENDING, });
  return api.post('/api/admin/app_settings/generate')
    .then((response) => {
      dispatch({
        type: POST_NEW_API_KEY_FULFILLED,
        payLoad: response.data,
      });

      toast.success('New api key has been successfully updated');
    })
    .catch((error) => {
      dispatch({
        type: POST_NEW_API_KEY_REJECTED,
        payLoad: error
      });

      toast.error('Cannot generate new api key');

      Promise.reject(error);
    });
};


export const getUserAccessTokens = (filter = '', page = '') => (dispatch) => {
  dispatch({
    type: GET_USER_ACCESS_TOKENS_PENDING,
    payload: []
  });
  return api.get('/api/admin/device_token', {
    params: {
      q: filter,
      page
    }
  })
    .then((response) => {
      dispatch({
        type: GET_USER_ACCESS_TOKENS_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_USER_ACCESS_TOKENS_REJECTED,
        payLoad: error.data
      });
      return Promise.reject(error.response.data);
    });
};


export const getUserAccessToken = token => (dispatch) => {
  dispatch({
    type: GET_USER_ACCESS_TOKEN_PENDING,
    payload: []
  });
  return api.get(`/api/admin/device_token/${token}`)
    .then((response) => {
      dispatch({
        type: GET_USER_ACCESS_TOKEN_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_USER_ACCESS_TOKEN_REJECTED,
        payLoad: error.data
      });
      return Promise.reject(error.response.data);
    });
};


export const updateUserAccessToken = (token, payLoad) => (dispatch) => {
  dispatch({
    type: POST_APP_SETTINGS_PENDING,
  });
  return api.patch(`/api/admin/device_token/${token}`, {device_token: payLoad})
    .then(() => {
      dispatch({
        type: POST_APP_SETTINGS_FULFILLED,
        payLoad,
      });

      toast.success('Access token has been successfully updated');
    })
    .catch((error) => {
      dispatch({
        type: POST_APP_SETTINGS_REJECTED,
        payLoad: error.response.data.errors
      });

      toast.error('Cannot update access token');

      Promise.reject(error.response.data.errors);
    });
};




// WEBPACK FOOTER //
// ./src/actions/app.js